import { __awaiter, __generator } from 'tslib';
import { magic } from '@gig/magic-sdk';
import { SESSION_START_EVENT, BETS_PLACED_EVENT, BET_WINS_EVENT } from '@gig/magic-messages';
import { SET_GAME_SESSION } from './game-session.constants.js';

var _a;
var getInitialState = function () { return ({
    sessionStart: new Date(),
    betsPlaced: 0,
    betWins: 0,
}); };
var getters = {
    betsPlaced: function (state) { return state.betsPlaced; },
    betWins: function (state) { return state.betWins; },
    sessionStart: function (state) { return state.sessionStart; },
};
var actions = {
    fetchGameSessionSummary: function (_a) {
        var commit = _a.commit;
        return __awaiter(this, void 0, void 0, function () {
            var payload, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, magic.methods.users.getGameSessionSummary()];
                    case 1:
                        payload = _b.sent();
                        if (payload.sessionStart && payload.betsPlaced) {
                            commit(SET_GAME_SESSION, payload);
                        }
                        return [2 /*return*/, payload];
                    case 2:
                        e_1 = _b.sent();
                        console.error('Failed to get the game session data', e_1);
                        return [2 /*return*/, false];
                    case 3: return [2 /*return*/];
                }
            });
        });
    },
    setGameSessionSummary: function (_a, data) {
        var commit = _a.commit;
        commit(SET_GAME_SESSION, data);
    },
    resetGameSessionSummary: function (_a) {
        var commit = _a.commit;
        commit(SET_GAME_SESSION, getInitialState());
    },
};
var gameSession = {
    namespaced: true,
    state: getInitialState(),
    actions: actions,
    getters: getters,
    mutations: (_a = {},
        _a[SET_GAME_SESSION] = function (state, payload) {
            state.sessionStart = payload.sessionStart;
            window.eventBus.publish(SESSION_START_EVENT, payload.sessionStart);
            state.betsPlaced = payload.betsPlaced;
            window.eventBus.publish(BETS_PLACED_EVENT, payload.betsPlaced);
            state.betWins = payload.betWins;
            window.eventBus.publish(BET_WINS_EVENT, payload.betWins);
        },
        _a),
};

export { actions, gameSession, getters };
